import styled from 'styled-components';

import IconLockBadge from 'components/icons/lock-badge';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`;
export const Description = styled.span`
  font-size: 0.8rem;
  font-weight: ${Styles.fontWeight.heavy};
`;
export const Label = styled.span`
  font-size: 0.7rem;
  font-weight: ${Styles.fontWeight.heavy};
`;
export const PromoLink = styled.a`
  font-size: 0.7rem;
  font-weight: ${Styles.fontWeight.heavy};
  color: ${Styles.color.primary};
`;
export const IconDescription = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
`;
export const Icon = styled(IconLockBadge)`
  margin-right: 5px;
`;

export const ErrorMessage = styled.div`
  color: ${Styles.color.error};
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 1rem;
`;
